<script setup>
import { onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import LaisModal from 'dashboard/components-next/LaisModal.vue';
import LaisPrimaryButton from 'dashboard/components-next/LaisPrimaryButton.vue';
import introImage from 'dashboard/assets/images/sales-registration-intro.png';

const STORAGE_KEY = 'startInfo';
const { t } = useI18n();
const show = ref(false);

const dismiss = () => {
  show.value = false;
  window.localStorage.setItem(STORAGE_KEY, 'true');
};

onMounted(() => {
  const storedValue = window.localStorage.getItem(STORAGE_KEY);
  show.value = storedValue === null || storedValue === 'false';
  if (storedValue === null) window.localStorage.setItem(STORAGE_KEY, 'false');
});
</script>

<template>
  <LaisModal
    :show="show"
    disable-escape-key-down
    max-width-class="max-w-[960px]"
    @close="dismiss"
  >
    <div
      class="relative grid gap-6 md:grid-cols-[minmax(0,0.9fr)_minmax(0,1.1fr)] md:items-center"
    >
      <button
        type="button"
        class="absolute right-0 top-0 z-10 grid size-9 place-items-center rounded-full text-lais-text-muted hover:bg-lais-primary-50 focus-visible:outline-none focus-visible:shadow-lais-focus"
        :aria-label="t('SALES.INTRO.CLOSE')"
        data-test="sales-registration-intro-close"
        @click="dismiss"
      >
        <span class="i-lucide-x size-4" aria-hidden="true" />
      </button>
      <div
        class="flex min-h-64 items-center justify-center rounded-lais bg-lais-bg-soft p-4 md:min-h-[27rem]"
      >
        <img
          :src="introImage"
          :alt="t('SALES.INTRO.IMAGE_ALT')"
          class="max-h-[27rem] w-full object-contain"
        />
      </div>
      <div class="space-y-5 pt-8 md:pt-0">
        <h2
          class="pr-10 font-redHatDisplay text-2xl font-bold leading-tight text-lais-text"
        >
          {{ t('SALES.INTRO.TITLE') }}
        </h2>
        <div class="space-y-4 text-sm leading-6 text-lais-text-muted">
          <p>{{ t('SALES.INTRO.PARAGRAPH_ONE') }}</p>
          <p>{{ t('SALES.INTRO.PARAGRAPH_TWO') }}</p>
          <p>{{ t('SALES.INTRO.PARAGRAPH_THREE') }}</p>
        </div>
        <div class="flex justify-end">
          <LaisPrimaryButton
            icon="i-lucide-arrow-right"
            data-test="sales-registration-intro-start"
            @click="dismiss"
          >
            {{ t('SALES.INTRO.START') }}
          </LaisPrimaryButton>
        </div>
      </div>
    </div>
  </LaisModal>
</template>
